import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import VelocityTracker from "./VelocityTracker";
var MAX_POINTERS = 20;
var PointerTracker = /*#__PURE__*/ function() {
    "use strict";
    function PointerTracker() {
        _class_call_check(this, PointerTracker);
        _define_property(this, "velocityTracker", new VelocityTracker());
        _define_property(this, "trackedPointers", new Map());
        _define_property(this, "touchEventsIds", new Map());
        _define_property(this, "lastMovedPointerId", void 0);
        _define_property(this, "cachedAverages", {
            x: 0,
            y: 0
        });
        this.lastMovedPointerId = NaN;
        for(var i = 0; i < MAX_POINTERS; ++i){
            this.touchEventsIds.set(i, NaN);
        }
    }
    _create_class(PointerTracker, [
        {
            key: "addToTracker",
            value: function addToTracker(event) {
                if (this.trackedPointers.has(event.pointerId)) {
                    return;
                }
                this.lastMovedPointerId = event.pointerId;
                var newElement = {
                    lastX: event.x,
                    lastY: event.y,
                    timeStamp: event.time,
                    velocityX: 0,
                    velocityY: 0
                };
                this.trackedPointers.set(event.pointerId, newElement);
                this.mapTouchEventId(event.pointerId);
                this.cachedAverages = {
                    x: this.getLastAvgX(),
                    y: this.getLastAvgY()
                };
            }
        },
        {
            key: "removeFromTracker",
            value: function removeFromTracker(pointerId) {
                this.trackedPointers.delete(pointerId);
                this.removeMappedTouchId(pointerId);
            }
        },
        {
            key: "track",
            value: function track(event) {
                var element = this.trackedPointers.get(event.pointerId);
                if (!element) {
                    return;
                }
                this.lastMovedPointerId = event.pointerId;
                this.velocityTracker.add(event);
                var _this_velocityTracker_getVelocity = _sliced_to_array(this.velocityTracker.getVelocity(), 2), velocityX = _this_velocityTracker_getVelocity[0], velocityY = _this_velocityTracker_getVelocity[1];
                element.velocityX = velocityX;
                element.velocityY = velocityY;
                element.lastX = event.x;
                element.lastY = event.y;
                this.trackedPointers.set(event.pointerId, element);
                var avgX = this.getLastAvgX();
                var avgY = this.getLastAvgY();
                this.cachedAverages = {
                    x: avgX,
                    y: avgY
                };
            }
        },
        {
            key: "mapTouchEventId",
            value: //Mapping TouchEvents ID
            function mapTouchEventId(id) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.touchEventsIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _sliced_to_array(_step.value, 2), mappedId = _step_value[0], touchId = _step_value[1];
                        if (isNaN(touchId)) {
                            this.touchEventsIds.set(mappedId, id);
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "removeMappedTouchId",
            value: function removeMappedTouchId(id) {
                var mappedId = this.getMappedTouchEventId(id);
                if (!isNaN(mappedId)) {
                    this.touchEventsIds.set(mappedId, NaN);
                }
            }
        },
        {
            key: "getMappedTouchEventId",
            value: function getMappedTouchEventId(touchEventId) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.touchEventsIds.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        if (value === touchEventId) {
                            return key;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return NaN;
            }
        },
        {
            key: "getVelocityX",
            value: function getVelocityX(pointerId) {
                var _this_trackedPointers_get;
                return (_this_trackedPointers_get = this.trackedPointers.get(pointerId)) === null || _this_trackedPointers_get === void 0 ? void 0 : _this_trackedPointers_get.velocityX;
            }
        },
        {
            key: "getVelocityY",
            value: function getVelocityY(pointerId) {
                var _this_trackedPointers_get;
                return (_this_trackedPointers_get = this.trackedPointers.get(pointerId)) === null || _this_trackedPointers_get === void 0 ? void 0 : _this_trackedPointers_get.velocityY;
            }
        },
        {
            key: "getLastX",
            value: function getLastX(pointerId) {
                if (pointerId !== undefined) {
                    var _this_trackedPointers_get;
                    return (_this_trackedPointers_get = this.trackedPointers.get(pointerId)) === null || _this_trackedPointers_get === void 0 ? void 0 : _this_trackedPointers_get.lastX;
                } else {
                    var _this_trackedPointers_get1;
                    return (_this_trackedPointers_get1 = this.trackedPointers.get(this.lastMovedPointerId)) === null || _this_trackedPointers_get1 === void 0 ? void 0 : _this_trackedPointers_get1.lastX;
                }
            }
        },
        {
            key: "getLastY",
            value: function getLastY(pointerId) {
                if (pointerId !== undefined) {
                    var _this_trackedPointers_get;
                    return (_this_trackedPointers_get = this.trackedPointers.get(pointerId)) === null || _this_trackedPointers_get === void 0 ? void 0 : _this_trackedPointers_get.lastY;
                } else {
                    var _this_trackedPointers_get1;
                    return (_this_trackedPointers_get1 = this.trackedPointers.get(this.lastMovedPointerId)) === null || _this_trackedPointers_get1 === void 0 ? void 0 : _this_trackedPointers_get1.lastY;
                }
            }
        },
        {
            key: "getLastAvgX",
            value: // Some handlers use these methods to send average values in native event.
            // This may happen when pointers have already been removed from tracker (i.e. pointerup event).
            // In situation when NaN would be sent as a response, we return cached value.
            // That prevents handlers from crashing
            function getLastAvgX() {
                var avgX = this.getSumX() / this.trackedPointers.size;
                return isNaN(avgX) ? this.cachedAverages.x : avgX;
            }
        },
        {
            key: "getLastAvgY",
            value: function getLastAvgY() {
                var avgY = this.getSumY() / this.trackedPointers.size;
                return isNaN(avgY) ? this.cachedAverages.y : avgY;
            }
        },
        {
            key: "getSumX",
            value: function getSumX(ignoredPointer) {
                var sumX = 0;
                this.trackedPointers.forEach(function(value, key) {
                    if (key !== ignoredPointer) {
                        sumX += value.lastX;
                    }
                });
                return sumX;
            }
        },
        {
            key: "getSumY",
            value: function getSumY(ignoredPointer) {
                var sumY = 0;
                this.trackedPointers.forEach(function(value, key) {
                    if (key !== ignoredPointer) {
                        sumY += value.lastY;
                    }
                });
                return sumY;
            }
        },
        {
            key: "getTrackedPointersCount",
            value: function getTrackedPointersCount() {
                return this.trackedPointers.size;
            }
        },
        {
            key: "getTrackedPointersID",
            value: function getTrackedPointersID() {
                var keys = [];
                this.trackedPointers.forEach(function(_value, key) {
                    keys.push(key);
                });
                return keys;
            }
        },
        {
            key: "getData",
            value: function getData() {
                return this.trackedPointers;
            }
        },
        {
            key: "resetTracker",
            value: function resetTracker() {
                this.velocityTracker.reset();
                this.trackedPointers.clear();
                this.lastMovedPointerId = NaN;
                for(var i = 0; i < MAX_POINTERS; ++i){
                    this.touchEventsIds.set(i, NaN);
                }
            }
        }
    ], [
        {
            key: "shareCommonPointers",
            value: function shareCommonPointers(stPointers, ndPointers) {
                return stPointers.some(function(pointerId) {
                    return ndPointers.includes(pointerId);
                });
            }
        }
    ]);
    return PointerTracker;
}();
export { PointerTracker as default };
